import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { GetCheckListForClientRequest, GetCheckListForClientResponse, PostCheckListAnswerRequest, PostCheckListAnswerResponse} from '../models/checklist.models';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getCheckListForClient(request: GetCheckListForClientRequest): Observable<GetCheckListForClientResponse> {
    return this.http.get<GetCheckListForClientResponse>(`${this.apiUrl}/checklist/get-checklist`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }
  postCheckListAnswer(request: PostCheckListAnswerRequest): Observable<PostCheckListAnswerResponse> {
    return this.http.post<PostCheckListAnswerResponse>(`${this.apiUrl}/checklist/post-checklist-answer`, request, { headers: this.getHeaders() });
  }
}